"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import c from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ l(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m16.569 12.006 4.957 4.867c.316.294.488.712.473 1.143a1.47 1.47 0 0 1-.454 1.126l-2.325 2.379c-.29.31-.7.48-1.126.47-.425.01-.835-.16-1.126-.47l-5.012-4.958-4.903 4.958a1.5 1.5 0 0 1-1.144.472 1.49 1.49 0 0 1-1.216-.472l-2.234-2.288a1.47 1.47 0 0 1-.454-1.126c-.04-.466.142-.923.49-1.235l4.94-4.866-4.94-4.958a1.5 1.5 0 0 1-.472-1.07 1.5 1.5 0 0 1 .472-1.145l2.198-2.36a1.47 1.47 0 0 1 1.126-.454c.432-.016.849.156 1.144.472l4.994 4.94 4.957-4.958a1.5 1.5 0 0 1 1.144-.472 1.47 1.47 0 0 1 1.126.454l2.288 2.288c.316.295.488.712.472 1.144.016.432-.156.85-.472 1.144zm1.534 9.987h.01-.037z",
        clipRule: "evenodd"
      }
    )
  }
), a = e(t);
export {
  a as XThick,
  a as default
};
